import { render } from "./Editorial.vue?vue&type=template&id=7464e783&scoped=true"
import script from "./Editorial.vue?vue&type=script&lang=js"
export * from "./Editorial.vue?vue&type=script&lang=js"

import "./Editorial.vue?vue&type=style&index=0&id=7464e783&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7464e783"]])

export default __exports__